import { TypedDocumentNode } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { Query } from 'graphql/generated/graphqlTypes';
import { GET_CLOUD_CONTROLLERS } from 'graphql/v2/queries';
import { useRegisterBackgroundRefetch } from 'hooks/useBackgroundRefetch/useBackgroundRefetch';
import { useEffect, useMemo } from 'react';
import { TranslatedHookProps } from '../hooks.types';

// Typing the document (instead of passing generics to the Apollo hook) avoids the deprecated hook signatures.
const GET_CLOUD_CONTROLLERS_TYPED: TypedDocumentNode<Pick<Query, 'cloudController'>> = GET_CLOUD_CONTROLLERS;

const useCloudControllerList = ({ translation, handleFetchError }: TranslatedHookProps) => {
  const { loading, error, data } = useQuery(GET_CLOUD_CONTROLLERS_TYPED, {
    notifyOnNetworkStatusChange: true
  });

  useEffect(() => {
    if (error) {
      handleFetchError(translation.cloud_controllers_error_fetching);
      console.error(error);
    }
  }, [error]);

  const cloudControllersLoading = loading && !data;

  // `loading`, not the network status: a failed refetch leaves the status on `error` and the indicator stays on.
  useRegisterBackgroundRefetch(loading && !!data);

  const cloudControllers = useMemo(() => data?.cloudController.getCloudControllers ?? [], [data]);

  return { cloudControllers, cloudControllersLoading };
};

export default useCloudControllerList;
